import { useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

import AdminDashboard from "./AdminDashboard";
import DriverDashboard from "./DriverDashboard";
import OwnerDashboard from "./OwnerDashboard";
import NotActiveAccount from "../no-auth/NotActiveAccount";
// import CompanyDashboard from "./CompanyDashboard";

export default function DashboardLayout() {
    const { companySlug } = useParams();
    const { user, userProfile, company } = useAuth();

    // Super admin (notify company)
    if (companySlug === "notify") {
        return <OwnerDashboard />;
    }

    console.log(user)

    if (userProfile?.role === "driver") {
        return <DriverDashboard />;
    }

    // Admin role inside a normal company
    // if (user?.role === "admin") {
    //     return <AdminDashboard />;
    // }

    // Default company dashboard
    return <AdminDashboard />;
}
